<template>
  <div class="consultation-data">
    <span class="text-base-semibold"><slot name="txtConsultationConsent">Beratungseinwilligung</slot></span>
    <div class="checkbox-group">
      <label>
        <div class="input-wrapper">
          <input type="checkbox" id="dataMatchIdent" v-model="selectedInfoExchangeConsent" required />
          <span class="custom-checkbox"></span>
        </div>
        <span class="text-base" v-html="dataHandlingTerms"></span>
      </label>
    </div>
    <div class="checkbox-group">
      <label>
        <div class="input-wrapper">
          <input type="checkbox" id="contact-consent-activation-summary" v-model="selectedContactConsent" required />
          <span class="custom-checkbox"></span>
        </div>
        <span class="text-base" v-html="bewCheckoutTerms"></span>
      </label>
    </div>
  </div>
</template>
<script>
import syncProperty from '../../../../mixins/syncProperty'

export default {
  name: 'ConsultationConsent',

  computed: {
    dataHandlingTerms: function() {
      return this.consents_.find(item => item.name === 'data_handling_terms')?.text || ''
    },
    bewCheckoutTerms: function() {
      return this.consents_.find(item => item.name === 'bew_checkout_terms')?.text || ''
    },
    consents_: function() {
      return Array.isArray(this.consents) ? this.consents : []
    }
  },
  props: {
    consents: {
      type: Array
    }
  },
  mixins: [
    syncProperty('selectedInfoExchangeConsentProp', 'selectedInfoExchangeConsent'),
    syncProperty('selectedContactConsentProp', 'selectedContactConsent')
  ]
}
</script>
